import schoolAxiosInstance from "@quest/school-axios";
import { Mentor, Student, User } from "../types/user.type";
import { RolePermissions } from "../types/permission.type";
import { BaseGetRequestParams, BaseGetRequestResponse } from "@quest/types";

class UserService {
  private api = schoolAxiosInstance;

  async getUser() {
    const response = await this.api.get<User>("/users/me");

    return response.data;
  }

  async getStudentDetailsByIdpId(idpId: string) {
    const response = await this.api.get<Student>(`/student/idp/${idpId}`);

    return response.data;
  }

  async getUserPermissions(roleName: string) {
    const response = await this.api.get<RolePermissions>(
      `/tenant/permissions/role/${roleName}`
    );

    return response.data.data;
  }

  async updateUserProfile(profile_image: string | null, idpId: string) {
    const response = await this.api.put(`/users/${idpId}`, {
      profile_image,
    });

    return response.data;
  }

  async getNotificationUnreadCount() {
    const response = await this.api.get(
      "notifications/notification/unread-count"
    );

    return response.data;
  }

  async getMentorList(params: BaseGetRequestParams) {
    const response = await this.api.get<BaseGetRequestResponse<Mentor>>(
      "/users/mentor-list",
      { params }
    );

    return response.data.data;
  }

  async getAdminList(params: BaseGetRequestParams) {
    const response = await this.api.get<BaseGetRequestResponse<Mentor>>(
      "/users/admin-list",
      { params }
    );

    return response.data.data;
  }

  async logout(access_token: string) {
    const response = await this.api.post("/tenant/auth/logout", {
      access_token,
    });

    return response.data;
  }
}

export const userService = new UserService();
